import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnitssService {

  baseUrl = `${environment.apis.base}/unitss`;

  constructor(private readonly http: HttpClient) { }

  datatable(page?: number, options?: any): Observable<Object> {
    let httpParams = new HttpParams();

		if (typeof page === 'number') {
			httpParams = httpParams.append('page', page);
		}

		if ('key' in options && options.key.trim() !== '') {
			httpParams = httpParams.append('search', options.key);
		}
		if (options && 'client_id' in options && options.client_id) {
			httpParams = httpParams.append('client_id', options.client_id);
		}

		return this.http.get<any>(this.baseUrl, {params: httpParams});
  }

  getConnectedUnits(params: { minutes?: number; hours?: number; client_id?: number; only?: number } = {}) {
  const url = `${environment.apis.base}/unitss/connected`;
  return this.http.get<any>(url, { params: params as any });
}


  show(id: number): Observable<Object> {
    const url = `${this.baseUrl}/${id}`;

    return this.http.get<any>(url);
  }

  createOrUpdate(data: RxFormGroup, id?: number): Observable<Object> {
    let url = this.baseUrl;
	const dataToSend = data.value;

    if (id) {
		url += `/${id}`;
		Object.assign(dataToSend, {'_method': 'PUT'});
		return this.http.post<any>(url, dataToSend);
	} else {
		return this.http.post<any>(url, dataToSend);
	}
  }

  getUnits(): Promise<any> {
    const url = `${environment.apis.base}/getUnits`;
    console.log(url)

    return this.http.get<any>(url).toPromise();
  }

  async getUnitsFlat(): Promise<any[]> {
      let url = environment.apis.base;

      url += `/unitss/flat`;

      return this.http.get<any>(url).toPromise();
  }
  async getUnitsByClient(clientId: number | null): Promise<any[]> {
      let url = environment.apis.base;

      url += `/unitss/flat?client_id=${clientId}`;

      return this.http.get<any>(url).toPromise();
  }

  delete(id: number): Observable<Object> {
    const url = `${this.baseUrl}/${id}/delete`;

    return this.http.post<any>(url, {});
  }

  getDataByUrl(evidence): any {
	return new Date(evidence.date * 1000);
}
}
